import { render, staticRenderFns } from "./CmgPaymentsAndGiftCardsPage.vue?vue&type=template&id=84032f94&scoped=true&lang=pug&"
import script from "./cmg-payments-and-gift-cards-page.ts?vue&type=script&lang=ts&"
export * from "./cmg-payments-and-gift-cards-page.ts?vue&type=script&lang=ts&"
import style0 from "./CmgPaymentsAndGiftCardsPage.vue?vue&type=style&index=0&id=84032f94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84032f94",
  null
  
)

export default component.exports